/* eslint-disable @typescript-eslint/no-explicit-any */
import { tiposDocumentosApi } from '../../../common/services/apis/tiposDocumentosApi.ts';
import { tokenApi } from '../../../common/services/apis/tokenApi.ts';
import { ENV_CONFIG } from '../../../config/config.ts';
import { loadTiposDocs, setTiposDocs } from '../slices/tiposDocumentosSlices.ts';

export const getTiposDocs = () => {
    return async (dispatch: any) => {

        dispatch(loadTiposDocs());
        
        let token = await tokenApi.then((tokenresultado) => tokenresultado);
       
        const desToken = token.data.split(',');
        const numeroToken=desToken[1].split('=');
      
        const { data } = await tiposDocumentosApi(numeroToken[1]).get(``);
      
        dispatch(setTiposDocs({ tiposDocs: data }));
    }
}